/**
 * EE API Roles 前端服務（呼叫 /api/ee/api_roles/*）
 */
import axios from '../api/axios';
import { I18nField } from '../types';

const BASE = '/api/ee/api_roles';

export interface ApiRole {
  id: number;
  role_code: string;
  role_name: I18nField;
  description: string | null;
  is_active: boolean;
  edit_by: number;
  created_at: string;
  updated_at: string;
  key_count: number;
}

export interface ApiRoleCreate {
  role_code: string;
  role_name: I18nField;
  description?: string | null;
  is_active?: boolean;
}

export interface ApiRoleUpdate {
  role_code?: string;
  role_name?: I18nField;
  description?: string | null;
  is_active?: boolean;
}

export const listApiRoles = async (params?: {
  is_active?: boolean;
  search?: string;
}): Promise<ApiRole[]> => {
  const res = await axios.get(`${BASE}/`, { params });
  return res.data;
};

export const getApiRole = async (id: number): Promise<ApiRole> => {
  const res = await axios.get(`${BASE}/${id}`);
  return res.data;
};

export const createApiRole = async (payload: ApiRoleCreate): Promise<ApiRole> => {
  const res = await axios.post(`${BASE}/`, payload);
  return res.data;
};

export const updateApiRole = async (id: number, payload: ApiRoleUpdate): Promise<ApiRole> => {
  const res = await axios.put(`${BASE}/${id}`, payload);
  return res.data;
};

export const deleteApiRole = async (id: number): Promise<void> => {
  await axios.delete(`${BASE}/${id}`);
};
